import { render, staticRenderFns } from "./MenuButtonCard.vue?vue&type=template&id=248c6c99&scoped=true&"
import script from "./MenuButtonCard.vue?vue&type=script&lang=js&"
export * from "./MenuButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuButtonCard.vue?vue&type=style&index=0&id=248c6c99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c6c99",
  null
  
)

export default component.exports